<template>
    <div class="topic">
        <div style="margin-bottom: 20px">
            <el-button size="small" @click="addTab()" :disabled="isdisable">
                添加题目
            </el-button>
        </div>
        <el-tabs v-model="editableTabsValue" type="card" closable @tab-remove="removeTab">
            <el-tab-pane v-for="(item, index) in editableTabs" :key="item.name" :label="item.title" :name="item.name">
                <MyForm ref="resultdemoRef" :types="2" :id="testid" :list="Tmobject[index]" v-if="isLoaded"
                    :resultsList="resultsList" :istrue="isdisable" />
                <!--   -->

            </el-tab-pane>
        </el-tabs>
        <div class="submitbtn">
            <el-button type="primary" @click="onSubmitHandel">保存全部题目</el-button>
            <!-- <el-button @click="copyxuanxiang">复制选项</el-button> -->
        </div>
    </div>
</template>
  
<script>
import MyForm from "./topic_form.vue";
import { saveTestQuestion } from "@/api/coupon";
import { questionInfo, questionStore } from "@/api/exercises";
export default {
    data() {
        return {
            editableTabsValue: "1",
            editableTabs: [
                {
                    title: "题目1",
                    name: "1",
                    content: "Tab 1 content",
                },
            ],
            tabIndex: 2,
            form: {
                name: "",
                region: "",
                date1: "",
                date2: "",
                delivery: false,
                type: [],
                resource: "",
                desc: "",
            },
            type: 0,
            testid: 0,
            Tmobject: [],
            isLoaded: true,
            resultsList: [],
            istype: 2,
            errordilaog: true,
            formobject: [],
            canProceed:true,
            isdisable:false
        };
    },
   async created() {
        const hash = window.location.hash;
        const params = new URLSearchParams(hash.slice(hash.indexOf("?") + 1));
        this.testid = params.get("id");
        //   this.type = params.get("type");
        //   this.result_type = params.get("result_type");
        // console.log(this.testid);

       await this.getTestQuestionHandel();
    },
    mounted() {
        // console.log(this.Tmobject,'111');
    },
    computed: {
        isDataReady() {
            return this.Tmobject.length > 0;
        },
        isbutton() {
        return this.editableTabs.length <= 1;
    }
    },
    components: {
        MyForm,
    },
    methods: {
        copyxuanxiang() {
            var formValues = [];
            this.editableTabs.forEach((item, index) => {
                const resultdemoRef = this.$refs["resultdemoRef"][index];
                const formData = resultdemoRef.submitForm();
                formValues.push(formData);
            });
            const promises = [...formValues];
            const objects = promises.map((promise) => {
                return promise.then((result) => {
                    return result;
                });
            });

            Promise.all(objects)
                .then((results) => {
                    console.log("原始", results);

                    let formValues;
                    if (results.some((obj) => !obj.hasOwnProperty("index"))) {
                        const dataWithIndex = results.map((obj, index) => {
                            return {
                                ...obj,
                                index: obj.hasOwnProperty("index")
                                    ? obj.index
                                    : index + 1,
                            };
                        });

                        console.log("dataWithIndex排序前", dataWithIndex);
                        formValues = dataWithIndex.sort(
                            (a, b) => a.index - b.index
                        );
                        console.log("dataWithIndex排序后", formValues);
                        this.resultsList = formValues;
                    } else {
                        console.log("原始", results);
                        formValues = results.sort((a, b) => a.index - b.index);
                        console.log("results11", formValues);
                        this.resultsList = formValues;
                    }
                })
                .catch((error) => { });
        },
        addTab(targetName) {
            // this.istype = targetName;
            let arrlength = this.editableTabs.length - 1
           
            let andOne = this.editableTabs[arrlength].name
            console.log(this.editableTabs[arrlength].name,'andOne',Number(andOne));
            let newTabName = ( Number(andOne) + 1) +'';
            this.editableTabs.push({
                title: "题目" +( Number(andOne) + 1),
                name: newTabName,
                content: "New Tab content",
            });
            this.editableTabsValue = newTabName;
            console.log(newTabName, this.editableTabs,arrlength);
        },
        removeTab(targetName) {
            console.log(this.isbutton,this.editableTabs.length);
            if(this.isdisable){
                return 
            }
            this.$confirm("此操作将会删除该题目, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    // console.log(targetName, this.editableTabs);
                    if(!this.isbutton){
                        console.log(this.isbutton);
                    let tabs = this.editableTabs;
                    let activeName = this.editableTabsValue;
                    if (activeName === targetName) {
                        tabs.forEach((tab, index) => {
                            if (tab.name === targetName) {
                                let nextTab =tabs[index + 1] || tabs[index - 1];
                                if (nextTab) {
                                    activeName = nextTab.name;
                                }
                            }
                        });
                    }
                    this.editableTabsValue = activeName;
                    this.editableTabs = tabs.filter((tab) => tab.name !== targetName
                    );
                    console.log(this.editableTabs,'removtab');
                    this.$message({
                        type: "success",
                        message: "删除成功!",
                    });
                    }else{
                        this.$message({
                        type: "error",
                        message: "最后一项不可删除!",
                    });
                    }
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消删除",
                    });
                });
        },
        onSubmitHandel() {
            var formValues = [];
            this.editableTabs.forEach((item, index) => {
                const resultdemoRef = this.$refs["resultdemoRef"][index];
                const formData = resultdemoRef.submitForm();
                formValues.push(formData);
            });
            const promises = [...formValues];
            const objects = promises.map((promise) => {
                return promise.then((result) => {
                    return result;
                });
            });
            console.log(formValues, 'formValues');
            Promise.all(objects)
                .then((results) => {
                    console.log("原始", results);
                    let formValues;
                    this.canProceed = true;
                    if (results.some((obj) => !obj.hasOwnProperty("index"))) {
                        const dataWithIndex = results.map((obj, index) => {
                            return { ...obj, index: obj.hasOwnProperty("index") ? obj.index : index + 0, };
                        });

                        console.log("dataWithIndex排序前", dataWithIndex);
                        formValues = dataWithIndex.sort((a, b) => a.index - b.index);
                        console.log(this.canProceed, '1');
                        this.isverify(formValues)
                        // if(!this.canProceed){
                        //     return
                        // }
                    } else {
                        formValues = results.sort((a, b) => a.index - b.index);
                        // formValues = JSON.stringify(results);
                        console.log(formValues);
                        this.isverify(formValues) 
                        console.log('else',this.canProceed);
                    }
                    if(!this.canProceed){
                            return
                        }
                    let newArray = formValues.map((item) => {
                        // 判断是否有option属性且其中包含checkistrue字段
                        if (item.option && item.option.some((opt) => opt.hasOwnProperty("checkistrue"))
                        ) {
                            // 创建一个新的对象副本，移除checkistrue字段
                            let newItem = {
                                ...item, option: item.option.map((opt) => {
                                    let { checkistrue, ...rest } = opt;
                                    return rest;
                                }),
                            };
                            return newItem;
                        } else {
                            // 如果没有checkistrue字段，直接返回原对象
                            return item;
                        }
                    });
                    console.log("formValues", newArray);
                    newArray = JSON.stringify(newArray);
                    let data = {
                        id: this.testid,
                        question: newArray,
                    };
                    console.log(data,'data');
                    questionStore(data).then((res) => {
                        console.log(res);
                        if (res.code == 1) {
                            this.$message({
                                message: "恭喜你，保存成功",
                                type: "success",
                            });
                            this.$router.push("/exercises/list");
                        }
                    });
                })
                .catch((error) => { });
        },

        getTestQuestionHandel() {
            let data = {
                id: this.testid,
            };
            questionInfo(data).then((res) => {
                console.log(res,'2');
                if (res.code == 1) {
                    if(res.data.question == null || res.data.question == undefined || res.data.question == ''){
                        this.Tmobject = [];
                    }else{
                    this.Tmobject = res.data.question;
                    this.isdisable = res.data.relation_status==1?true:false
                    this.handleLoadingComplete();
                    let arrLength = this.Tmobject.length - 1;
                    var generatedTabs = [];
                    for (let i = 0; i < arrLength; i++) {
                        this.editableTabs.push({
                            title: `题目${i + 2}`,
                            name: `${i + 2}`,
                            content: `Tab ${i + 2} content`,
                        });
                    }
                    }
                    console.log(this.Tmobject,'2222');
                } else {
                    this.handleLoadingComplete();
                }
            });
        },
        handleLoadingComplete() {
            // 根据你的实际情况进行判断，如果所有接口都加载完毕，将isLoaded设置为true
            this.isLoaded = true;
        },
        deepCopyArray(arr) {
            var copiedArray = [];
            for (var i = 0; i < arr.length; i++) {
                if (Array.isArray(arr[i])) {
                    copiedArray.push(deepCopyArray(arr[i]));
                } else {
                    copiedArray.push(arr[i]);
                }
            }
            return copiedArray;
        },
        isverify(formValues,) {
            console.log('formValues1');
            for (let index = 0; index < formValues.length; index++) {
                const question = formValues[index];
                // 检查 question 是否为空
                if (question.question.trim() === "") {
                    this.canProceed = false;
                    this.$message({
                        message: `请填写题目!`,
                        type: "error",
                        // duration:0
                    });
                    break; // 提前退出循环
                }
                console.log('formValues2');
                // 检查每个选项的 answer 是否为空
                for ( let optionIndex = 0; optionIndex < question.option.length;optionIndex++) {
                    const option = question.option[optionIndex];
                    if (option.answer.trim() === "") {
                        this.canProceed = false;
                        console.log("hasSelected1");
                        this.$message({
                            message: `请正确填写题目的选项!`,
                            type: "error",
                            // duration:0
                        });
                        break; // 提前退出循环
                    }
                }
                console.log('formValues3');
                if (!this.canProceed) {
                    console.log('....');
                    break; // 如果出现问题，终止整个验证过程
                }
                if (question.type === "radio") {
                    // 检查是否至少有一个选项被选中
                    let hasSelected = question.option.some(
                        (option) => option.right === "1"
                    );
                    console.log(hasSelected, "hasSelected");
                    if (!hasSelected) {
                        this.canProceed = false;
                        this.errordilaog = false;
                        // errorMessage = `请选择题目${index + 1}正确答案!`;
                        this.$message({
                            message: `请选择题目正确答案!`,
                            type: "error",
                            // duration:0
                        });
                    }
                }
                console.log('formValues4');
                if (!this.canProceed) {
                    console.log('....');
                    break; // 如果出现问题，终止整个验证过程
                }
                console.log(question.type,'question.type');
                if (question.type === "checkbox") {
                    // 将选中的选项转换为1，未选中的转换为0，并检查至少有两个选项被选中
                    let selectedCount = question.option.filter((option) => option.right == '1').length;
                    console.log(selectedCount,'selectedCount');
                    if (selectedCount < 2) {
                        this.canProceed = false;
                        this.errordilaog = false;
                        // errorMessage = `请选择题目${index + 1}两个以上的正确答案!`;
                        this.$message({
                            message: `请选择两个以上的正确答案!`,
                            type: "error",
                            // duration:0
                        });
                    }else{
                        console.log('selectedCount',2222);
                    }
                }
                if (!this.canProceed) {
                    console.log('....');
                    break; // 如果出现问题，终止整个验证过程
                }
            }
        }
    },
};
</script>
  
<style>
.submitbtn {
    margin-left: 200px;
    margin-top: 60px;
}
</style>